import { gql } from '@apollo/client';
import { useInput } from 'lib/hooks/use-input';
import { useNewBooksellerMutation } from 'lib/graphql-generated';
import { Button } from 'components/buttons/button';
import { StandardInput } from 'components/forms/input';

const NEW_BOOKSELLER = gql`
  mutation NewBookseller($data: booksellers_insert_input!) {
    insert_booksellers_one(object: $data) {
      id
    }
  }
`;

interface Props {
  handleClose: () => void;
}
export const NewBookseller = ({ handleClose }: Props) => {
  const name = useInput<string>('');
  const avatar = useInput<string>('');
  const videoUrl = useInput<string>('');
  const about = useInput<string>('');

  const [save, { data, error, loading }] = useNewBooksellerMutation({
    refetchQueries: ['GetAllBooksellers'],
    onCompleted: () => handleClose(),
  });

  const canSave =
    name.isModified && avatar.isModified && videoUrl.isModified && !loading;

  const handleSave = () => {
    save({
      variables: {
        data: {
          avatar: avatar.value,
          name: name.value,
          video_url: videoUrl.value,
          about: about.value,
        },
      },
    });
  };

  return (
    <form className='[ p-4 sm:p-6 ] [ flex flex-row flex-wrap space-y-4 ] bg-white shadow rounded-md'>
      <label
        htmlFor='name'
        className='w-full text-sm font-medium text-gray-700'>
        Name
        <input
          {...name.bind}
          type='text'
          name='name'
          id='name'
          autoComplete='off'
          autoCorrect='off'
          className='mt-1 focus:ring-green-default focus:border-green-default block w-full shadow-sm sm:text-sm border-gray-300 rounded-md'
        />
      </label>
      <label
        htmlFor='avatar'
        className='w-full text-sm font-medium text-gray-700'>
        Avatar URL
        <input
          {...avatar.bind}
          type='url'
          name='avatar'
          id='avatar'
          autoComplete='off'
          autoCorrect='off'
          className='mt-1 focus:ring-green-default focus:border-green-default block w-full shadow-sm sm:text-sm border-gray-300 rounded-md'
        />
      </label>
      <label
        htmlFor='videoUrl'
        className='w-full text-sm font-medium text-gray-700'>
        Video URL
        <input
          {...videoUrl.bind}
          type='url'
          name='videoUrl'
          id='videoUrl'
          autoComplete='off'
          autoCorrect='off'
          className='mt-1 focus:ring-green-default focus:border-green-default block w-full shadow-sm sm:text-sm border-gray-300 rounded-md'
        />
      </label>
      <StandardInput
        label='About'
        id='about'
        name='about'
        bind={{ ...about.bind }}
        type='text'
      />
      <Button
        buttonSize='md'
        loading={loading}
        buttonType='primary'
        disabled={!canSave}
        className='ml-auto'
        onClick={handleSave}>
        Save
      </Button>
    </form>
  );
};
